class InstagramBlock extends HTMLElement {
        constructor() {
            super();
            this.querySelector('[data-load-more-block]').addEventListener('click', this.onLoadMore.bind(this))
        }
        onLoadMore(e) {
            const eleHide = this.querySelectorAll('.hidden');
            if (eleHide.length) {
                let number_show = (eleHide.length > 6 ? 6 : eleHide.length);
                for (let i = 0; i < number_show; i++) {
                    eleHide[i].classList.remove('hidden');
                }
                (eleHide.length > 6 ? '' : e.target.classList.add('hidden'));
            }
        }
    }
    customElements.define('instagram-block', InstagramBlock);